import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "./i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "sv";
    return localStorage.getItem("np_lang") || "sv";
  });

  const setLanguage = useCallback((l) => {
    setLang(l);
    try {
      localStorage.setItem("np_lang", l);
      document.documentElement.lang = l;
    } catch (_) {}
  }, []);

  const value = useMemo(() => {
    const t = translations[lang] || translations.sv;
    return { lang, t, setLanguage, toggle: () => setLanguage(lang === "sv" ? "en" : "sv") };
  }, [lang, setLanguage]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
};
